import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row fit no-wrap justify-center q-pb-sm" }
const _hoisted_2 = { class: "row fit no-wrap justify-center" }

import { computed } from 'vue';
import { usePagesUtilStore } from '@/stores/pagesUtilStore';
import { useInstitutionalStore } from '@/stores/institutionalStore';
import { EnumMultipleSingleMode, EnumButtonSizes } from '@/enums/enums';
import messages from '@/utils/messages';


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalDeleteInstitutionalConfirmation',
  setup(__props) {

const pagesUtilStore = usePagesUtilStore();
const institutionalStore = useInstitutionalStore();

/**
 * TEXTOS DO MODAL
 * (PDF pede exatamente essa mensagem)
 */
const modalTitle = computed(() => {
  return pagesUtilStore.modalDeleteInstitutionalConfirmationMode ===
    EnumMultipleSingleMode.MULTIPLE
    ? 'Excluir Cadastro(s)'
    : 'Excluir Cadastro';
});

const modalDescription = computed(() => {
  return pagesUtilStore.modalDeleteInstitutionalConfirmationMode ===
    EnumMultipleSingleMode.MULTIPLE
    ? 'Deseja realmente excluir o(s) Cadastro(s) selecionado(s)?'
    : 'Deseja realmente excluir este Cadastro?';
});


const onConfirmDelete = async () => {
  try {
    let ids: number[] = []

    if (pagesUtilStore.modalDeleteInstitutionalConfirmationMode === EnumMultipleSingleMode.SINGLE) {
      // ✅ SINGLE → pega o id do detail
      const id = institutionalStore.institutionalDetail?.id
      if (!id) {
        messages.showErrorMsg('Nenhum cadastro selecionado para exclusão.')
        closeModal()
        return
      }
      ids = [id]
    } else {
      // ✅ MULTIPLE → pega os selecionados
      if (!institutionalStore.selectedInstitutionals.length) {
        messages.showErrorMsg('Nenhum cadastro selecionado para exclusão.')
        closeModal()
        return
      }

      const canDelete = institutionalStore.canDeleteSelectedInstitutionals()
      if (!canDelete) {
        messages.showErrorMsg('Existem cadastros selecionados que não podem ser excluídos.')
        closeModal()
        return
      }

      ids = institutionalStore.selectedInstitutionals.map(item => item.id)
    }

    await institutionalStore.deleteInstitutionals(ids)

    messages.showSuccessMsg('Cadastro(s) excluído(s) com sucesso!')

  } catch (error) {
    messages.showErrorMsg('Erro ao tentar excluir o cadastro institucional.')
  } finally {
    closeModal()
  }
}



/**
 * CANCELAR
 */
const onCancel = () => {
  closeModal();
};

const closeModal = () => {
  pagesUtilStore.showModalDeleteInstitutionalConfirmation = false;
};

return (_ctx: any,_cache: any) => {
  const _component_c_modal_title = _resolveComponent("c-modal-title")!
  const _component_c_q_btn = _resolveComponent("c-q-btn")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_dialog, {
      modelValue: _unref(pagesUtilStore).showModalDeleteInstitutionalConfirmation,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(pagesUtilStore).showModalDeleteInstitutionalConfirmation) = $event)),
      "no-backdrop-dismiss": true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          class: "midia-app-padding-modal",
          style: {"width":"448px"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_c_modal_title, {
                propModalTitle: modalTitle.value,
                propModalDescription: modalDescription.value
              }, null, 8, ["propModalTitle", "propModalDescription"]),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_c_q_btn, {
                  id: "btn-excluir",
                  style: {"width":"100%"},
                  propBtnLabel: "EXCLUIR",
                  propBtnFunction: onConfirmDelete,
                  propBtnTransparent: false,
                  propBtnSize: _unref(EnumButtonSizes).LARGE_1
                }, null, 8, ["propBtnSize"])
              ]),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_c_q_btn, {
                  id: "btn-cancelar",
                  style: {"width":"100%"},
                  propBtnLabel: "CANCELAR",
                  propBtnTransparent: true,
                  propBtnSize: _unref(EnumButtonSizes).LARGE_1,
                  onClick: onCancel
                }, null, 8, ["propBtnSize"])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})